/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {SpecialOrderCommandModel} from '../contracts/special-order-command.model';
import {SpecialOrderBaseModel} from '../contracts/special-order-base.model';
import {MultiStatusModel} from '../../generic/contracts/multi-status.model';

@Injectable({
    providedIn: 'root'
})
export class SpoCreateNewService {

    private createNewSpoUrl = `${environment.specialOrdersBaseUrl}/api/specialOrder`;
    private createAndSendNewSpoUrl = `${environment.specialOrdersBaseUrl}/api/specialOrder/submit`;
    private sendNewSpoUrl = `${environment.specialOrdersBaseUrl}/api/specialOrder`;
    private httpOptions = {
        headers: new HttpHeaders({
            'accept': 'application/json',
            'Content-Type': 'application/json',
        })
    };

    constructor(private http: HttpClient) {
    }

    createNewSpo(specialOrder: SpecialOrderCommandModel): Observable<SpecialOrderBaseModel> {
        return this.http.post<SpecialOrderBaseModel>(this.createNewSpoUrl, specialOrder, this.httpOptions);
    }

    createAndSendNewSpo(specialOrder: SpecialOrderCommandModel): Observable<HttpResponse<SpecialOrderBaseModel | MultiStatusModel>> {
        return this.http.post<SpecialOrderBaseModel | MultiStatusModel>(this.createAndSendNewSpoUrl, specialOrder, {
                    ...this.httpOptions,
                    observe: 'response'
                }
        );
    }

    sendSavedSpo(specialOrderNumber: string): Observable<HttpResponse<MultiStatusModel>> {
        return this.http.put<MultiStatusModel>(
                `${this.sendNewSpoUrl}/${specialOrderNumber}/submit`,
                undefined,
                {
                    ...this.httpOptions,
                    observe: 'response'
                }
        );
    }

    resubmitSavedSpo(specialOrderNumber: string): Observable<HttpResponse<MultiStatusModel>> {
        return this.http.put<MultiStatusModel>(
                `${this.sendNewSpoUrl}/${specialOrderNumber}/resubmit`,
                undefined,
                {
                    ...this.httpOptions,
                    observe: 'response'
                }
        );
    }
}
